import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getDetailSettings,
  updateDetailSettings,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../../Common/extra/loading";
import Addons from "./Addons";
import AddressAddon from "./AddressAddon";

const DetailSettingsIndex = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const detailData = useSelector((s) => s?.Signatures?.detailSettings?.data);
  const [contacts, setContacts] = useState([""]);
  const [address, setAddress] = useState([]);
  const [socialLinks, setSocialLinks] = useState({
    facebook: "",
    instagram: "",
    twitter: "",
  });
  const [companyDetail, setCompanyDetail] = useState({
    companyname: "",
    companywebsiteaddress: "",
  });

  const [errors, setErrors] = useState({
    contacts: "",
    address: "",
    facebook: "",
    instagram: "",
    twitter: "",
  });

  useEffect(() => {
    dispatch(getDetailSettings());
  }, []);

  useEffect(() => {
    if (detailData) {
      setSocialLinks(detailData?.contact_social);
      setContacts(detailData?.contact_phones);
      setAddress(detailData?.contact_address);
      setCompanyDetail({
        companyname: detailData?.companyname,
        companywebsiteaddress: detailData?.companywebsiteaddress,
      });
    }
  }, [detailData]);

  const handleContactChange = (e) => {
    setContacts(e);
  };
  const handleAddressChange = (e) => {
    setAddress(e);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSocialLinks((pre) => ({ ...pre, [name]: value }));
  };

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompanyDetail((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const callBack = (res) => {
      setLoading(false);
      if (res.data) {
        dispatch(getDetailSettings());
        toast.success("Success!");
      }
    };
    dispatch(
      updateDetailSettings(
        {
          contact_address: address,
          contact_phones: contacts,
          contact_social: { ...socialLinks },
          ...companyDetail,
        },
        callBack
      )
    );
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row className="main-dashobar-basic">
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item>Basic Settings</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="12" className="my-2">
                      <div className="top mb-2">
                        <Breadcrumb className="detail-setting-breadcrumb">
                          <Breadcrumb.Item>Social Links</Breadcrumb.Item>
                        </Breadcrumb>
                      </div>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Facebook Link
                      </label>
                      <input
                        type="text"
                        name="facebook"
                        value={socialLinks.facebook}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.facebook}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Instagram Link
                      </label>
                      <input
                        type="text"
                        name="instagram"
                        value={socialLinks.instagram}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.instagram}
                      </span>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Twitter Link
                      </label>
                      <input
                        type="text"
                        name="twitter"
                        value={socialLinks.twitter}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.twitter}
                      </span>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="top mb-2">
                        <Breadcrumb className="detail-setting-breadcrumb">
                          <Breadcrumb.Item>Company Details</Breadcrumb.Item>
                        </Breadcrumb>
                      </div>
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Company Name
                      </label>
                      <input
                        type="text"
                        name="companyname"
                        value={companyDetail.companyname}
                        onChange={handleCompanyChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Company Website Address
                      </label>
                      <input
                        type="text"
                        name="companywebsiteaddress"
                        value={companyDetail.companywebsiteaddress}
                        onChange={handleCompanyChange}
                        placeholder=""
                        className="form-control"
                      />
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="top mb-2">
                        <Breadcrumb className="pt-3">
                          <Breadcrumb.Item>Contacts Details</Breadcrumb.Item>
                        </Breadcrumb>
                      </div>
                    </Col>
                    <Addons
                      data={contacts}
                      handleChange={handleContactChange}
                    />

                    <Col lg="12" className="my-2">
                      <div className="top mb-2">
                        <Breadcrumb>
                          <Breadcrumb.Item>Address Details</Breadcrumb.Item>
                        </Breadcrumb>
                      </div>
                    </Col>
                    <AddressAddon
                      data={address}
                      handleChange={handleAddressChange}
                    />

                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          // disabled={errors.disabled}
                          onClick={handleSubmit}
                          className={`d-inline-flex align-items-center justify-content-center me-2`}
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/customers`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default DetailSettingsIndex;
